import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import InsightsIcon from '@mui/icons-material/Insights';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CampaignIcon from '@mui/icons-material/Campaign';
import type { AiAssistantRole, Document, DocumentCategory, DocumentType } from '../../../core/types/data-models';
import type { BlockedNextDoc } from './documentTypeCatalog';

// AiAssistantRole.avatarIcon is a free-text MUI icon name set per-role in the
// backend seed data (backend/prisma/seed-data/ai-assistant-roles/roles.json) —
// only the icons actually used there are mapped; anything else (a role added
// later with an icon outside this set, or no icon at all) falls back to a
// generic assistant glyph rather than failing to render.
const ASSISTANT_ROLE_ICON_MAP: Record<string, typeof SmartToyOutlinedIcon> = {
  TravelExplore: TravelExploreIcon,
  Insights: InsightsIcon,
  Assignment: AssignmentIcon,
  AccountTree: AccountTreeIcon,
  Campaign: CampaignIcon,
};

export function roleIcon(avatarIcon: string | null): typeof SmartToyOutlinedIcon {
  return (avatarIcon && ASSISTANT_ROLE_ICON_MAP[avatarIcon]) || SmartToyOutlinedIcon;
}

/**
 * One AI assistant role with the slice of the project that belongs to its
 * document category — computed once by AiAssistantsSection and rendered by
 * either layout (AssistantRoleCard / AssistantRoleRow).
 */
export interface AssistantRoleData {
  role: AiAssistantRole;
  /** The category's generated documents, in document-type order. */
  relatedDocs: Document[];
  /** Not-yet-generated document types of the category (Next Steps' list, scoped to the role). */
  recommended: { docType: DocumentType; category: DocumentCategory | undefined }[];
  /** The category's closest-to-unlocked doc type when nothing in it can be generated yet. */
  blocked: BlockedNextDoc | undefined;
  /** Active root document types of the category not generated yet. */
  remaining: number;
}
